import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "21",
  fill: "none",
  viewBox: "0 0 22 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M15.125 2A5.5 5.5 0 0 0 11 3.916 5.5 5.5 0 0 0 6.875 2C4.05 2 1.833 4.218 1.833 7.042c0 3.465 3.117 6.288 7.838 10.578L11 18.82l1.329-1.21c4.72-4.28 7.837-7.103 7.837-10.568C20.166 4.218 17.948 2 15.125 2M11.09 16.254l-.091.092-.092-.092c-4.363-3.95-7.242-6.563-7.242-9.212 0-1.834 1.375-3.209 3.209-3.209 1.411 0 2.786.908 3.272 2.164h1.714c.477-1.256 1.852-2.164 3.264-2.164 1.833 0 3.208 1.375 3.208 3.209 0 2.649-2.878 5.261-7.242 9.212"
    }, null, -1)
  ]))]))
}
export default { render: render }